
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-product-marketing-teams",
      function () {
        return require("private-next-pages/for-product-marketing-teams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-product-marketing-teams"])
      });
    }
  